import * as InternalTypes from '../common/InternalTypes';

export class StartupConfig {
	private readonly _qualtricsInternalUri: string;
	private readonly _enableQualtricsRestrictedMode: boolean = false;
	private readonly _productName: string;
	private readonly _platformType: string;
	private readonly _scopeSet: string[] = [];

	constructor(startupConfig: InternalTypes.StartupConfig) {
		this._qualtricsInternalUri = startupConfig.qualtricsInternalUri;
		this._enableQualtricsRestrictedMode = !!startupConfig.enableQualtricsRestrictedMode;
		this._productName = startupConfig.productName;
		this._platformType = startupConfig.platformType;
		this._scopeSet = startupConfig.scopeSet || [];
	}

	get qualtricsInternalUri(): string {
		return this._qualtricsInternalUri;
	}

	get enableQualtricsRestrictedMode(): boolean {
		return this._enableQualtricsRestrictedMode;
	}

	get productName(): string {
		return this._productName;
	}

	get platformType(): string {
		return this._platformType;
	}

	get scopeSet(): string[] {
		return this._scopeSet;
	}
}
